import { VisualSimilarityIcon } from "../../pages/DataPage/CardsView/DataPageFilters/SearchContainer/Icons";
import React from "react";

export default function FindSimilarityIcon() {
  return <VisualSimilarityIcon />;
}
